import { createSlice } from '@reduxjs/toolkit';
import type { SuggestionsState } from './types';

const initialState: SuggestionsState = {
  suggestions: [],
  loading: false,
  error: null
};

export const slice = createSlice({
  name: 'suggestions',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    getSuggestions(state, action) {
      state.suggestions = action.payload;
      state.loading = false;
    }
  }
});

export default slice.reducer;
